// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o5MTDLBMqgwKkTShAvCk{width:100%;padding:32px 0 24px}.ImzQ9DHSo9oufVr9zwvQ{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `o5MTDLBMqgwKkTShAvCk`,
	"btn": `ImzQ9DHSo9oufVr9zwvQ`
};
export default ___CSS_LOADER_EXPORT___;
